import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Beacon.module.scss.js';

var Beacon = function (_a) {
    var style = _a.style, className = _a.className;
    return (jsx("div", { className: classNames(styles.wrapper, className), style: style, children: jsx("div", { className: styles.beacon, id: 'beacon' }) }));
};
var Beacon$1 = React.memo(Beacon);

export { Beacon$1 as default };
//# sourceMappingURL=Beacon.js.map
